import { render, staticRenderFns } from "./ui-drop-down-component.vue?vue&type=template&id=1685b545&scoped=true&"
import script from "./ui-drop-down-component.vue?vue&type=script&lang=ts&"
export * from "./ui-drop-down-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-drop-down-component.vue?vue&type=style&index=0&id=1685b545&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685b545",
  null
  
)

export default component.exports